module.exports = __webpack_public_path__ + "static/media/post2.44d32f35.jpg";